
<div class="row" class="row border Page-Header">
    <div class="col-12 p-0">
      <h6 class="HeadContent">Power User List</h6>
    </div>
  </div>
  <div class="row pt-1">
    <div class="col-12">
       
        <!-- <div class="row p-1">
            <div class="col-12"> -->
              <div class="d-flex">
                <div class="px-1">
                    <h6 class="HeadContent1">User Profiles</h6>
                </div>
                <div class="px-1 pt-1">
                    <button type="button" class="btn btn-sm bl-btn" (click) = "OnClickAddButton()">Add New User</button>
                </div>
                
              </div>
            </div>
          </div>

          <div class="row pt-1">
            <div class="col-12 scroll-style">
              <table class="table table-bordered table-hover table-responsive">
                <thead>
                  <tr class="table-active">
                   
                    <th  scope="col">Power User #</th>
                    <th scope="col">Name</th>
                    <th scope="col">Status</th>
                    <th scope="col">Phone Number</th>
                    <th scope="col">Email Address</th>
                    <th scope="col">Education</th>
                    <th scope="col">Experience</th>
                    <th scope="col">Create Date</th>
                    <th scope="col">Created By</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let s of dataSource;let i=index" (click) = "onClickUserListRow(s)">
                    <td>{{s.powerUser}}</td>
                    <td>{{s.name}}</td>
                    <td>{{s.status}}</td>
                    <td>{{s.primaryPhoneNumber}}</td>
                    <td>{{s.emailAddress}}</td>
                    <td>{{s.education}}</td>
                    <td>{{s.experience}}</td>
                    <td>{{s.createDate | date: "dd/MM/yyyy"}}</td>
                    <td>{{s.createdBy}}</td>
                  </tr>
                </tbody>
              </table>
              <!-- <script>
                $(document).ready(function () {
                   $('#sortTable').DataTable();
                 });
               </script> -->
              
      
      </div>
    </div>

  <!-- <div class="row pt-1">
    <div class="col-12">
      <div class="scroll-style border">
        <div class="d-flex border-bottom">
          <div class="px-1 text-left Rl-hdr ">No.</div>
          <div class="px-1 text-left Rl-hdr ">
            <p class="Rl-col-1">Power User #</p>
          </div>
          <div class="px-1 text-left Rl-hdr ">
            <p class="Rl-col-1">Name</p>
          </div>
          <div class="px-1 text-left Rl-hdr ">
            <p class="Rl-col-2">Status</p>
          </div>
          <div class="px-1 text-left Rl-hdr ">
            <p class="Rl-col-1">Phone Number</p>
          </div>
          <div class="px-1 text-left Rl-hdr ">
            <p class="Rl-col-3">Email Address</p>
          </div>
          <div class="px-1 text-left Rl-hdr ">
            <p class="Rl-col-2">Education</p>
          </div>
          <div class="px-1 text-left Rl-hdr ">
            <p class="Rl-col-2">Experience</p>
          </div>
          <div class="px-1 text-left Rl-hdr ">
            <p class="Rl-col-1">Create Date</p>
          </div>
          <div class="px-1 text-left Rl-hdr ">
            <p class="Rl-col-1">Created By</p>
          </div>
          
        </div>
  
        <div class="d-flex invRow" *ngFor="let s of dataSource; let i = index">
          <div class="px-2 text-right pt-1 pb-1  border-bottom">{{i+1}}</div>
          <div class="px-1 text-left pt-1 pb-1  border-bottom">
             <p class="Rl-col-1">{{s.powerUser}}</p> 
            
          </div>
          <div class="px-1 text-left pt-1 pb-1 border-bottom">
            <p class="Rl-col-1"> {{s.name}}</p>
          </div>
          <div class="px-1 text-left pt-1 pb-1 border-bottom">
            <p class="Rl-col-2">{{s.status}} </p>
          </div>
          <div class="px-1 text-left pt-1 pb-1 border-bottom">
            <p class="Rl-col-1">{{s.primaryPhoneNumber}}</p>
          </div>
          <div class="px-1 text-left pt-1 pb-1 border-bottom">
            <p class="Rl-col-3">{{s.emailAddress}} </p>
          </div>
          <div class="px-1 text-left pt-1 pb-1 border-bottom">
            <p class="Rl-col-2">{{s.education}}</p>
          </div>
          <div class="px-1 text-left pt-1 pb-1 border-bottom">
            <p class="Rl-col-2">{{s.experience}}</p>
          </div>
          <div class="px-1 text-left pt-1 pb-1 border-bottom">
            <p class="Rl-col-1">{{s.createDate}}</p>
          </div>
          <div class="px-1 text-left pt-1 pb-1 border-bottom">
            <p class="Rl-col-1">{{s.createdBy}}</p>
          </div>
          </div>
        </div>
  
      
  
      </div>
    </div> -->

  <!-- <div class="d-flex">
          <div class="p-3 m-3">No search results</div>
        </div> -->


    <div class="row pt-1">
        <div class="col-12">
           
          
                  <div class="d-flex">
                    <div class="px-1">
                        <h6 class="HeadContent1">Power User Roles</h6>
                    </div>
                   
                    
                  </div>
                </div>
              </div>
    
     <div class="row pt-1">
        <div class="col-12 scroll-style">
          <table class="table table-bordered table-hover table-responsive">
            <thead>
              <tr class="table-active">
               
                <th class="col">Power User #</th>
                <th scope="col">Name</th>
                <th scope="col">Role</th>
                <th class="col-md-4">Subjects</th>
                <th scope="col">Role Status</th>
                <th scope="col">Start Date</th>
                <th scope="col">End Date</th>
                <th scope="col">Assigned By</th>
                <th scope="col">Approved By</th>
               
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let elem of PowerUserSource;let i=index" (click) = "onClickUserRoleListRow(elem)">
                <td>{{elem.PowerUserId}}</td>
                <td>{{elem.name}}</td>
                <td>{{elem.PowerUserRoleType}}</td>
                <td>{{elem.Subjects}}</td>
                <td>{{elem.Power_User_Role_Status_Type_Name}}</td>
                <td>{{elem.StartDate | date: "dd/MM/yyyy"}}</td>
                <td>{{elem.EndDate | date: "dd/MM/yyyy"}}</td>
                <td>{{elem.assignedBy}}</td>
                <td>{{elem.approvedBy}}</td>
               
              </tr>
            </tbody>
          </table>
  </div>
</div>
      <!-- <div class="row pt-1">
        <div class="col-12">
          <div class="scroll-style border">
            <div class="d-flex border-bottom">
              <div class="px-1 text-left Rl-hdr ">No.</div>
              <div class="px-1 text-left Rl-hdr ">
                <p class="Rl-col-1">Power User #</p>
              </div>
              <div class="px-1 text-left Rl-hdr ">
                <p class="Rl-col-1">Name</p>
              </div>
              <div class="px-1 text-left Rl-hdr ">
                <p class="Rl-col-2">Status</p>
              </div>
              <div class="px-1 text-left Rl-hdr ">
                <p class="Rl-col-1">Phone Number</p>
              </div>
              <div class="px-1 text-left Rl-hdr ">
                <p class="Rl-col-3">Email Address</p>
              </div>
              <div class="px-1 text-left Rl-hdr ">
                <p class="Rl-col-2">Education</p>
              </div>
              <div class="px-1 text-left Rl-hdr ">
                <p class="Rl-col-2">Experience</p>
              </div>
              <div class="px-1 text-left Rl-hdr ">
                <p class="Rl-col-1">Create Date</p>
              </div>
              <div class="px-1 text-left Rl-hdr ">
                <p class="Rl-col-1">Created By</p>
              </div>
             
            </div>
      
            <div class="d-flex invRow" >
              <div class="px-2 text-right pt-1 pb-1  border-bottom"></div>
              <div class="px-1 text-left pt-1 pb-1  border-bottom">
                 <p class="Rl-col-1"></p> 
                 
              </div>
              <div class="px-1 text-left pt-1 pb-1 border-bottom">
                <p class="Rl-col-1 link"></p>
              </div>
              <div class="px-1 text-left pt-1 pb-1 border-bottom">
                <p class="Rl-col-2"></p>
              </div>
              <div class="px-1 text-left pt-1 pb-1 border-bottom">
                <p class="Rl-col-1"></p>
              </div>
              <div class="px-1 text-left pt-1 pb-1 border-bottom">
                <p class="Rl-col-3"></p>
              </div>
              <div class="px-1 text-left pt-1 pb-1 border-bottom">
                <p class="Rl-col-2"></p>
              </div>
              <div class="px-1 text-left pt-1 pb-1 border-bottom">
                <p class="Rl-col-2"></p>
              </div>
              <div class="px-1 text-left pt-1 pb-1 border-bottom">
                <p class="Rl-col-1"></p>
              </div>
              <div class="px-1 text-left pt-1 pb-1 border-bottom">
                <p class="Rl-col-1"></p>
              </div>
              </div>
            </div>
      
          
      
          </div>
        </div> -->
  
  